let arr=[
    {name:'mg/kg',value:'mg/kg'},
    {name:'g/kg',value:'g/kg'},
    {name:'吨',value:'吨'},
    {name:'公顷',value:'公顷'},
    {name:'亩',value:'亩'},
    {name:'平米',value:'平米'},
    {name:'千克',value:'千克'},
    {name:'头',value:'头'},
    {name:'口',value:'口'}
]
export default arr